export default function copyToClipboard( text ) {
    navigator.clipboard
        .writeText( text )
        .then( function () {
            console.log( "Texte copié dans le presse-papiers" );
        } )
        .catch( ( err ) => {
            console.error( "Erreur lors de la copie du texte : ", err );
        } );
};
